// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  background-color: black;
  color: white;
}

h1 {
  color: red;
}

h6 {
  color: red;
  text-decoration: underline;
}`, "",{"version":3,"sources":["webpack://./src/app/components/access-denied/access-denied.component.scss"],"names":[],"mappings":"AAAA;EACI,uBAAA;EACA,YAAA;AACJ;;AAEA;EACI,UAAA;AACJ;;AAEA;EACI,UAAA;EACA,0BAAA;AACJ","sourcesContent":["body {\n    background-color: black;\n    color: white;\n}\n\nh1 {\n    color: red;\n}\n\nh6 {\n    color: red;\n    text-decoration: underline;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
